export const sources={webp:"__VITE_ASSET__DSFgBMD6__ 96w"};export const img={src:"__VITE_ASSET__Dy0zuDsH__",w:96,h:130};export default{sources:sources,img:img};